import { render, staticRenderFns } from "./trackinglabels.vue?vue&type=template&id=c24dcb88&scoped=true&lang=html"
import script from "./trackinglabels.vue?vue&type=script&lang=js"
export * from "./trackinglabels.vue?vue&type=script&lang=js"
import style0 from "./trackinglabels.vue?vue&type=style&index=0&id=c24dcb88&prod&lang=css"
import style1 from "./trackinglabels.vue?vue&type=style&index=1&id=c24dcb88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24dcb88",
  null
  
)

export default component.exports